import axios from 'axios';
import { ShopifyOrder } from '../models/ShopifyOrder';
import { Warehouse } from '../../stock/models/StockLine';

const API_URL = process.env.REACT_APP_API_URL;

interface ListShopifyOrdersProps {
  state?: string;
  since?: string;
  until?: string;
  page?: number;
  shippingService?: number;
  reference?: string;
  warehouse?: Warehouse | null;
}

interface PaginatedShopifyOrders {
  count: number;
  next: string;
  previous: string;
  results: Array<ShopifyOrder>;
}

const SHOPIFY_ORDERS_PER_PAGE = 20;

export function listShopifyOrders({
  state,
  since,
  until,
  shippingService,
  reference,
  page = 1,
  warehouse,
}: ListShopifyOrdersProps): Promise<{ data: PaginatedShopifyOrders }> {
  const endpoint = `${API_URL}/api/shopify-orders/`;
  const params = {
    state,
    promise_date__gte: since,
    promise_date__lte: until,
    shippingservice_id: shippingService,
    reference,
    offset: (page - 1) * SHOPIFY_ORDERS_PER_PAGE,
    limit: SHOPIFY_ORDERS_PER_PAGE,
    warehouse: warehouse ?? undefined,
  };

  return axios.get(endpoint, { params });
}

export enum BulkActionsEnum {
  GENERATE_PICKING_SHEET = 'generate_picking_sheet',
  GENERATE_WAREHOUSE_OPERATIONS_SHEET = 'generate_warehouse_operations_sheet',
  PRINT_TAGS = 'print_tags',
  SET_PROCESSING = 'set_processing',
  GENERATE_PRODUCTS_NECESSITY_SHEET = 'generate_products_necessity_sheet',
  PREPARE_ORDERS = 'prepare_orders',
  PREPARE_ORDERS_LEGACY = 'prepare_orders_legacy',
}

interface BulkActionProps {
  action: BulkActionsEnum;
  promise_date__gte: string;
  promise_date__lte: string;
  shippingService?: number;
  state: string;
  orders: Array<number>;
  reference?: string;
  warehouse?: Warehouse | null;
}
export function performBulkAction({
  action,
  promise_date__gte,
  promise_date__lte,
  shippingService,
  state,
  orders,
  reference,
  warehouse,
}: BulkActionProps) {
  const endpoint = `${API_URL}/api/shopify-orders/massive-actions/`;

  return axios.post(endpoint, {
    action,
    promise_date__gte,
    promise_date__lte,
    shippingservice_id: shippingService,
    state,
    orders,
    reference,
    warehouse: warehouse ?? undefined,
  });
}

export function importProduct(productId: string, category: string) {
  const endpoint = `${API_URL}/api/additional-products/import-shopify-product/`;
  return axios.post(endpoint, {
    product_id: productId,
    category,
  });
}
